var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1295,
    height: 333,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m0,167.9c0,-54.5 38.884,-88 101.06,-88l64.373,0l0,-79.9l80.567,0l0,251l-145.24,0c-61.877,0 -100.76,-32.2 -100.76,-83.1zm85,-2.7c0,20.9 12.653,31.8 36.96,31.8l43.04,0l0,-64l-42.64,0c-24.31,0 -37.36,11 -37.36,32.2zm682,-0.1c0,54.5 -38.884,88 -101.06,88l-64.373,0l0,79.9l-80.567,0l0,-251l145.24,0c61.877,0 100.76,32.2 100.76,83.1zm-85,2.7c0,-20.9 -12.668,-31.8 -37.007,-31.8l-42.993,0l0,64l42.693,0c24.34,0 37.307,-11 37.307,-32.2zm613,-2.7c0,54.5 -38.884,88 -101.06,88l-64.373,0l0,79.9l-80.567,0l0,-251l145.24,0c61.876,0 100.76,32.2 100.76,83.1zm-85,2.7c0,-20.9 -12.668,-31.8 -37.007,-31.8l-42.993,0l0,64l42.693,0c24.34,0 37.307,-11 37.307,-32.2zm-419,-1.2c0,-60.996 48.8,-93.6 116,-93.6s116,32.604 116,93.6c0,60.993 -48.8,94.4 -116,94.4c-67.2,-0.1 -116,-33.407 -116,-94.4zm153,-0.95c0,-29.733 -14.9,-44.65 -37.5,-44.65s-37.5,14.917 -37.5,44.65c0,29.332 14.9,45.35 37.5,45.35c22.7,-0.1 37.5,-16.018 37.5,-45.35zm-450,4.262c0,-60.994 -39.23,-97.912 -110.102,-97.912c-68.078,0 -111.898,36.918 -111.898,94.702c0,58.488 43.422,93.298 115.79,93.298c45.52,0 82.253,-17.054 101.618,-44.743l-57.696,-21.067c-9.982,10.935 -25.055,16.954 -40.926,16.954c-23.857,0 -40.427,-9.63 -44.72,-25.983c-0.3,-1.102 -0.5,-2.106 -0.698,-3.31l148.632,0l0,-11.938l0,-0.001zm-148,-25.913c1.902,-19.814 15.62,-32 39.45,-32c23.832,0 37.55,12.88 37.55,32l-77,0z",
    fill: "#ff2300"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepop);
export default __webpack_public_path__ + "static/media/depop.529485bd3e8b9f3153d772142e566374.svg";
export { ForwardRef as ReactComponent };